import React, { useState, useEffect } from 'react'
import { Input, Select, Pagination, message, Table, Button, Modal, Popover, Icon } from 'antd'
import { listSku, getListColorCheckItem, exportListColorCheckItem } from '../../../services/api/3dApi'
import FilterDateRangeV2 from '../../home/components/filters/FilterDateRangeV2'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import { createJobExport } from '../../../helpers/createJobExport'
import UseDebounce from '../../users/helpers/UseDebounce'
import moment from 'moment'
import _ from 'lodash'

const { Search } = Input
const { Option } = Select

const ITEM_STATUS = [
    { "name": "Chưa in", "value": "unprinted" },
    { "name": "Đã đẩy", "value": "pushed" },
    { "name": "Đã thiết kế", "value": "designed" },
    { "name": "Đã thêu", "value": "embroidered" },
    { "name": "Đã in", "value": "printed" },
    { "name": "Đã ép", "value": "transferred" },
    { "name": "QC sau ép", "value": "confirmed" },
    { "name": "Đang may", "value": "sewing" },
    { "name": "Hoàn thành", "value": "completed" },
]

const PRINTER = [
    { name: "Máy in 1", value: 'printer_1' },
    { name: "Máy in 2", value: 'printer_2' },
    { name: "Máy in 3", value: 'printer_3' },
    { name: "Máy in 4", value: 'printer_4' },
    { name: "Máy in 5", value: 'printer_5' },
    { name: "Máy in 6", value: 'printer_6' },
    { name: "Máy in 7", value: 'printer_7' },
    { name: "Máy in 8", value: 'printer_8' },
    { name: "Máy in 9", value: 'printer_9' },
    { name: "Máy in 10", value: 'printer_10' },
    { name: "Máy in 11", value: 'printer_11' },
    { name: "Máy in 12", value: 'printer_12' },
]

const ColorCheckItemPage = () => {

    const [listColorCheckItem, setListColorCheckItem] = useState([])
    const [name, setName] = useState('')
    const [skus, setSkus] = useState([])
    const [listSkus, setListSkus] = useState([])
    const [productionStatus, setProductionStatus] = useState([])
    const [printers, setPrinters] = useState("")
    const [limit, setLimit] = useState(200)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [pagination, setPagination] = useState({})
    const [src, setSrc] = useState('')
    const [date, setDate] = useState({})

    const debounceName = name === '' ? UseDebounce(name, 0) : UseDebounce(name, 500)

    useEffect(() => {
        _fetchOrderTypes()
    }, [])

    useEffect(() => {
        _fetchColorCheckItem(null, 'next')
    }, [limit, debounceName, productionStatus, skus, printers, date])

    const _fetchOrderTypes = async () => {
        try {
            const { data: response } = await listSku()

            const { data, success, error } = response

            if (!success) throw new Error(error)

            const regex = /\s/

            const newData = data.length > 0 && data.filter((item) => {
                return !regex.test(item.sku) && item
            })
            setListSkus(newData)

        } catch (e) {
            console.log(e.message)
        }
    }

    const _fetchColorCheckItem = async (cursor = null, direction = 'next') => {
        setLoading(true)
        try {
            const {created_at = {}} = Object.assign({}, date)
            const payload = {
                limit,
                direction,
            }

            const filters = {}

            if (cursor) payload.cursor = cursor
            if (!!productionStatus.length) filters.production_status = productionStatus
            if (!!printers.length) filters.printers = printers
            if (!!skus.length) filters.types = skus
            if (!!debounceName) {
                filters.batch_names = debounceName.trim().split(/[\s,]+/)
            }
            if(!!created_at.from && !!created_at.to){
                filters.created_at = {
                    from: created_at.from,
                    to: created_at.to
                }
            }

            if (!!Object.keys(filters).length) payload.filters = filters

            const { data: res = {} } = await getListColorCheckItem(payload)
            const { data: v, success, message: mess } = res

            if (!success) throw new Error(mess)

            const { data, pagination } = v

            setListColorCheckItem(mapApiToTableData(data))
            setPagination(pagination)
        } catch (e) {
            message.error(e.message)
        } finally {
            setLoading(false)
        }
    }

    const _exportColorCheckItem = async () => {
        setLoading(true)
        setError('')

        try {
            const {created_at = {}} = Object.assign({}, date)
            const payload = {}

            if (!!productionStatus.length) payload.production_status = productionStatus
            if (!!printers.length) payload.printers = printers
            if (!!skus.length) payload.types = skus
            if (!!debounceName) {
                payload.batch_names = debounceName.trim().split(/[\s,]+/)
            }
            if(!!created_at.from && !!created_at.to){
                payload.created_at = {
                    from: created_at.from,
                    to: created_at.to
                }
            }

            const { data: res } = await exportListColorCheckItem({ filters: payload })
            if (typeof res !== 'string') {
                const { success, message: mess, data } = res
                if (!success) throw new Error(mess)

                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            } else {
                if (res) downloadFileFromData(res, { filename: `color-check-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

        } catch (e) {
            setError(e.message)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const _handleChangeFilter = (field, value) => {
        if (field === "production_status") return setProductionStatus(value)
        if (field === "skus") return setSkus(value)
        if (field === "name") return setName(value)

        setPrinters(value)
    }

    const _handleChangeDate = (field, value) => {
        const cloneFilter = Object.assign({}, date)

        cloneFilter[field] = value

        if (value.from === '') {
            delete cloneFilter[field]
        }

        setDate(cloneFilter)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
    }

    const mapApiToTableData = (data = []) => {
        const rows = []

        data.forEach(group => {
            group.items.forEach((item, index) => {
                rows.push({
                    key: item._id,
                    barcode: group.barcode_number,
                    barcodeRowSpan: index === 0 ? group.items.length : 0,
                    item: `${group.barcode_number}_${item.item_number}`,
                    sku: item.type,
                    fileIn: item.preview_image || item.image,
                    meta: item.meta,
                    batch: item.batch_name || '-',
                    userCreate: item.user_create || '-',
                    printer: !!item.printer ? item.printer : '-',
                    status: item.production_status
                })
            })
        })

        return rows
    }

    const show_file_in = (preview) => {
        const newImage = new Image()
        if (!!preview) {
            newImage.src = preview
            const newWidth = newImage.width > newImage.height ? "100%" : "auto"
            const newHeight = newImage.width > newImage.height ? "auto" : "100%"

            return (
                <div className='position-relative'>
                    <div className={`Preview position-relative PriviewFileIn`}>
                        <img src={preview} className='position-absolute' alt='preview' style={{ width: newWidth, height: newHeight }} />
                    </div>
                </div>
            )
        }
    }

    const columns = [
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            render: (value, row) => ({
                children: value,
                props: { rowSpan: row.barcodeRowSpan }
            }),
            align: 'center',
        },
        {
            title: 'Item',
            dataIndex: 'item',
            align: 'center'
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            align: 'center'
        },
        {
            title: 'File in',
            dataIndex: 'fileIn',
            render: (img, record) => {
                const isCmyk = _.get(record, 'meta.infoData.generateOptions.imageOptions.cmyk') === true
                return !!img ? (
                    <Popover
                        placement="left"
                        content={show_file_in(img)}
                        overlayClassName={`previewFixed ${!!src ? 'd-none' : ''}`}
                    >
                        <div className="file-in">
                            <img src={img} alt="" style={{ width: 100, cursor: 'pointer' }} />
                            <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                <span className='Icon cursor-pointer mr-2' onClick={() => setSrc(img)}><Icon type='eye' /></span>
                            </div>
                            {isCmyk && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: 2,
                                    right: 2,
                                    backgroundColor: '#ff0000',
                                    color: '#ffffff',
                                    fontSize: 12,
                                    fontWeight: 'bold',
                                    padding: '0 3px',
                                    lineHeight: '13px',
                                    borderRadius: 2
                                }}>CMYK</div>
                            )}
                        </div>
                    </Popover>
                ) : '-'
            },
            align: 'center'
        },
        {
            title: 'Lô',
            dataIndex: 'batch',
            align: 'center',
            render: (batch, row) => (
                <div>
                    <div>{batch}</div>
                    <div className="font-weight-bold" style={{ fontSize: 12 }}>{row.userCreate}</div>
                </div>
            )
        },
        {
            title: 'Máy in',
            dataIndex: 'printer',
            align: 'center'
        },
        {
            title: 'Trạng thái item',
            dataIndex: 'status',
            render: status => {
                const { name = '' } = ITEM_STATUS.find(i => i.value === status) || {}

                return name || '-'
            },
            align: 'center'
        }
    ]

    const handleNext = () => {
        if (!pagination.has_next) return

        _fetchColorCheckItem(pagination.next_cursor, 'next')
    }

    const handlePrev = () => {
        if (!pagination.has_prev) return

        _fetchColorCheckItem(pagination.prev_cursor, 'prev')
    }

    return (
        <div className='ColorCheckItemPage'>
            <div className="container-fluid min-vh-100">
                <div className="col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="m-0">Danh sách cần kiểm soát hệ màu</h3>
                        </div>
                        <button
                            type="button"
                            className="ant-btn ant-btn-primary"
                            onClick={_exportColorCheckItem}>
                            <span>Export</span>
                        </button>
                    </div>

                    <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                        <div className='row align-items-start'>
                            <div className='FilterNameBatch col-12 col-xl-3 mb-3'>
                                <label className="d-block w-100 font-weight-bold mb-1">Tên lô</label>
                                <div className='SearchField'>
                                    <Search
                                        placeholder='Tìm kiếm theo tên Lô...'
                                        onChange={e => _handleChangeFilter("name", e.target.value)}
                                        allowClear={true}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-xl-3 mb-3">
                                <label className="d-block w-100 font-weight-bold mb-1">Trạng thái item</label>
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    showArrow={true}
                                    placeholder="Trạng thái item"
                                    onChange={v => _handleChangeFilter("production_status", v)}
                                    value={productionStatus}
                                    allowClear
                                    filterOption={(input, option) =>
                                        option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                                    }
                                >
                                    {
                                        ITEM_STATUS.map((option) => {
                                            return <Option key={option.value} value={option.value}>{option.name}</Option>
                                        })
                                    }
                                </Select>
                            </div>

                            <div className='col-12 col-xl-3 mb-3'>
                                <label className="d-block w-100 font-weight-bold mb-1">Loại sản phẩm</label>
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    showArrow={true}
                                    placeholder="Vui lòng chọn loại sản phẩm bạn muốn tìm kiếm"
                                    onChange={v => _handleChangeFilter("skus", v)}
                                    value={skus}
                                    allowClear
                                    filterOption={(input, option) =>
                                        option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                                    }
                                >
                                    {!!listSkus && listSkus.length > 0 &&
                                        listSkus.map((option) => {
                                            return <Option key={option._id} value={option.sku}>{option.sku}</Option>
                                        })
                                    }
                                </Select>
                            </div>

                            <div className='col-12 col-xl-3 mb-3'>
                                <label className="d-block w-100 font-weight-bold mb-1">Máy in</label>
                                <Select
                                    value={printers || []}
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder='Chọn máy in'
                                    allowClear
                                    filterOption={(input, option) =>
                                        option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                                    }
                                    onChange={(value) => _handleChangeFilter('printers', value)}
                                >
                                    {
                                        PRINTER.map((item, index) =>
                                            <Option key={index} value={item.value}>
                                                {item.name}
                                            </Option>
                                        )
                                    }
                                </Select>
                            </div>

                            <div className='col-12 col-xl-3 mb-3'>
                                <label className="font-weight-bold d-block">Thời gian đơn đẩy về</label>
                                <FilterDateRangeV2 
                                    field='created_at' 
                                    filters={date} 
                                    onDatesChange={_handleChangeDate} 
                                    showTime 
                                />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && (
                                <div className="text-danger mb-2">{error}</div>
                            )}
                        </div>
                        <Pagination
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100', '200']}
                            onShowSizeChange={_handleShowSizeChange} />
                    </div>

                    <Table
                        columns={columns}
                        dataSource={listColorCheckItem}
                        pagination={false}
                        bordered
                        loading={loading}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                        <Button
                            onClick={handlePrev}
                            disabled={!pagination.has_prev}
                            style={{ marginRight: 8 }}
                        >
                            Trang trước
                        </Button>

                        <Button
                            type="primary"
                            onClick={handleNext}
                            disabled={!pagination.has_next}
                        >
                            Trang sau
                        </Button>
                    </div>

                    <Modal
                        visible={!!src}
                        footer={null}
                        onCancel={() => setSrc('')}
                        centered
                    >
                        <img
                            src={src}
                            alt=""
                            style={{ width: '100%' }}
                        />
                    </Modal>
                </div>
            </div>
        </div>
    )
}

export default ColorCheckItemPage